import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthContextProvider } from './context/authContext/AuthContext'
import UserContextProvider from './context/userContext/UserContext'
import PostContextProvider from './context/postContext/PostContext'
import ResourceContextProvider from './context/resourceContext/ResourceContext'
import UploadDataContextProvider from './context/uploadDataContext/UploadDataContext'
const container = document.getElementById('root')
const root = ReactDOM.createRoot(container)

root.render(
  <AuthContextProvider>
    <UserContextProvider>
      <PostContextProvider>
        <ResourceContextProvider>
          <UploadDataContextProvider>
            <App />
          </UploadDataContextProvider>
        </ResourceContextProvider>
      </PostContextProvider>
    </UserContextProvider>
  </AuthContextProvider>
)
